/**
 * API reachability check for reducers, thunks, and utilities.
 * The web app has no offline mode, so it is always considered online;
 * only the desktop bridge provides real reachability detection.
 */
export const isOnline = () => {
  try {
    if (window.api?.isOnline) {
      return window.api.isOnline();
    }
  } catch {
    // Fall back to always-online when the desktop bridge is unavailable.
  }

  return true;
};

/**
 * OS-level link status. Use only for non-API flows (e.g. auto-update).
 */
export const isLinkOnline = () => {
  try {
    if (window.api?.isLinkOnline) {
      return window.api.isLinkOnline();
    }
  } catch {
    // Fall back to navigator when the desktop bridge is unavailable.
  }

  return typeof navigator !== "undefined" ? navigator.onLine : true;
};

export const onApiReachabilityChange = (cb: (online: boolean) => void) => {
  if (window.api?.onApiReachabilityChange) {
    window.api.onApiReachabilityChange(cb);
  }

  return () => {};
};
